import React from 'react';
import { FileTextIcon, LayersIcon, SparklesIcon } from 'lucide-react';
import { collagePrintables } from '../data/content';
type Placement = {
  index: number;
  className: string;
  lead?: boolean;
};

// Indexes refer to collagePrintables. Spans keep every card at its natural proportions.
const layout: Placement[] = [{
  index: 0,
  className: 'col-span-2 lg:col-span-7 z-10',
  lead: true
}, {
  index: 3,
  className: 'col-span-1 lg:col-span-3 lg:-ml-6 lg:rotate-2 z-20'
}, {
  index: 7,
  className: 'col-span-1 lg:col-span-2 lg:-ml-2 lg:-rotate-2 z-10'
}, {
  index: 1,
  className: 'col-span-1 lg:col-span-3 lg:-rotate-1 z-10'
}, {
  index: 2,
  className: 'col-span-2 lg:col-span-6 lg:-mx-4 z-20 order-first lg:order-none',
  lead: true
}, {
  index: 8,
  className: 'col-span-1 lg:col-span-3 lg:rotate-1 z-10'
}, {
  index: 5,
  className: 'col-span-2 lg:col-span-4 lg:rotate-1 z-10'
}, {
  index: 6,
  className: 'col-span-2 lg:col-span-4 lg:-mx-4 lg:-rotate-1 z-20'
}, {
  index: 4,
  className: 'col-span-2 lg:col-span-4 lg:rotate-1 z-10'
}];
const stats = [{
  value: '200+',
  label: 'Bible verses',
  Icon: SparklesIcon
}, {
  value: '20+',
  label: 'Printable designs',
  Icon: LayersIcon
}, {
  value: 'PDF',
  label: 'Ready to print',
  Icon: FileTextIcon
}];
export function ProductCollage() {
  return <div className="rounded-[32px] bg-white/70 px-5 pb-8 pt-10 shadow-card ring-1 ring-cream-line sm:px-8 lg:px-12 lg:pb-10 lg:pt-12" data-id="element-244" data-mp="3nz15xrd66h18">
      <div className="text-center" data-id="element-245" data-mp="390qnxkudai6o">
        <p className="font-display text-[64px] leading-none text-coral sm:text-[80px]" data-id="element-246" data-mp="394mtk9o425vj">200+</p>
        <p className="mt-2 text-lg font-extrabold uppercase tracking-[0.14em] text-navy sm:text-xl" data-id="element-247" data-mp="3dz0lg23kduvg">Bible Verses Ready to Share</p>
        <p className="mt-1.5 text-sm font-extrabold uppercase tracking-[0.18em] text-gold-deep" data-id="element-248" data-mp="3506sclpfzmmn">20+ printable Gospel-sharing designs</p>
      </div>

      <ul className="mt-10 grid grid-cols-2 items-center gap-3 sm:gap-4 lg:grid-cols-12 lg:gap-x-4 lg:gap-y-6" aria-label="Sample Gospel printables" data-id="element-249" data-mp="yb0hn4q32mqu">
        {layout.map(({
        index,
        className,
        lead
      }) => {
        const p = collagePrintables[index];
        return <li key={p.src} className={`relative ${className}`} data-id="element-250" data-mp="ws0n4qxttqbh">
              {lead && <>
                  <span className="absolute inset-0 hidden translate-x-2 translate-y-2 rotate-1 rounded-lg bg-white shadow-card ring-1 ring-navy/5 sm:block" aria-hidden="true" data-id="element-251" data-mp="ruiivdur7z9t" />
                  <span className="absolute inset-0 hidden translate-x-4 translate-y-4 rotate-2 rounded-lg bg-cream shadow-card ring-1 ring-navy/5 sm:block" aria-hidden="true" data-id="element-252" data-mp="1khmggxripbbk" />
                </>}
              <div className="relative rounded-lg bg-white p-2 shadow-sheet ring-1 ring-navy/5" data-id="element-253" data-mp="1arjq75bs6bgx">
                <img src={p.src} alt={p.alt} loading="lazy" className="h-auto w-full" data-id="element-254" data-mp="15syrjac6fzul" />
              </div>
            </li>;
      })}
      </ul>

      <dl className="mx-auto mt-10 grid max-w-3xl grid-cols-3 divide-x divide-cream-line rounded-2xl bg-cream px-2 py-5 sm:py-6" data-id="element-255" data-mp="1yifc5ltk2cg9">
        {stats.map(({
        value,
        label,
        Icon
      }) => <div key={label} className="flex flex-col items-center px-2 text-center sm:flex-row sm:justify-center sm:gap-3 sm:text-left" data-id="element-256" data-mp="25vy544qrgbq3">
            <Icon className="mb-2 h-6 w-6 text-coral sm:mb-0" aria-hidden="true" data-id="element-257" data-mp="2frhzuntl94d9" />
            <div data-id="element-258" data-mp="2kqkvjhnohy8k">
              <dd className="font-display text-3xl leading-none text-navy sm:text-4xl" data-id="element-259" data-mp="2kr4bistrqcjy">{value}</dd>
              <dt className="mt-1 text-[11px] font-extrabold uppercase tracking-[0.1em] text-ink-soft sm:text-xs" data-id="element-260" data-mp="2ot7oxmzzzr7v">{label}</dt>
            </div>
          </div>)}
      </dl>
    </div>;
}